import { SlideshowLightbox } from "lightbox.js-react";

interface ImageLightboxProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  alt?: string;
}

/**
 * CSS overrides for lightbox.js-react controls.
 * The library renders: iconsHeader > [controls(zoom btns), closeIcon(#closeBtn)]
 * We use :has(> div > #closeBtn) to target the iconsHeader container and
 * reposition zoom buttons to top-left and close button to top-right.
 */
const lightboxCSS = `
  /* Layout: full-width header, zoom left, close right */
  div:has(> div > #closeBtn) {
    position: fixed !important;
    top: 16px !important;
    left: 16px !important;
    right: 16px !important;
    width: auto !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  /* All lightbox buttons — consistent prominent style */
  div:has(> div > #closeBtn) button {
    background: rgba(0,0,0,0.7) !important;
    backdrop-filter: blur(8px) !important;
    -webkit-backdrop-filter: blur(8px) !important;
    border-radius: 12px !important;
    padding: 12px !important;
    min-width: 48px !important;
    min-height: 48px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    border: none !important;
  }

  /* All lightbox SVG icons — consistent size and color */
  div:has(> div > #closeBtn) button svg {
    width: 24px !important;
    height: 24px !important;
    color: white !important;
  }
`;

export function ImageLightbox({ open, onClose, imageUrl, alt = "Image" }: ImageLightboxProps) {
  const images = [
    {
      src: imageUrl,
      title: alt,
    },
  ];

  return (
    <>
      {open && <style>{lightboxCSS}</style>}
      <SlideshowLightbox
        images={images}
        showThumbnails={false}
        open={open}
        lightboxIdentifier="image-lightbox"
        onClose={onClose}
        theme="classic"
        lightboxWidth="100vw"
        disableImageZoom={false}
        maxZoomScale={5}
        iconColor="white"
        showFullScreenIcon={false}
        showThumbnailIcon={false}
        showSlideshowIcon={false}
        showArrows={false}
      />
    </>
  );
}
